const sharedStyles = {
    typography: {
        useNextVariants: true
    },
    paper: {
        padding: 20
    },
    profile: {
        '& .image-wrapper': {
            textAlign: 'center',
            position: 'relative',
            '& button': {
                position: 'absolute',
                top: '80%',
                left: '70%'
            }
        },
        '& .profile-image': {
            width: 200,
            height: 200,
            objectFit: 'cover',
            maxWidth: '100%',
            borderRadius: '50%'
        },
        '& .profile-details': {
            textAlign: 'center',
            '& span, svg': {
                verticalAlign: 'middle'
            }
        },
        '& hr': {
            border: 'none',
            margin: '0 0 10px 0'
        },
        '& svg.button': {
            '&:hover': {
                cursor: 'pointer'
            }
        }
    },
    buttons: {
        textAlign: 'center',
        '& a': {
            margin: '20px 10px'
        }
    },
    card: {
        position: 'relative',
        display: 'flex',
        marginBottom: 15
    },
    image: {
        width: 200,
        height: 170,
        objectFit: 'cover'
    },
    cover: {
        padding: 15,
        objectFit: 'cover',
        minWidth: '70%'
    },
    handle: {
        height: 25,
        width: 60,
        backgroundColor: '#673ab7',
        marginBottom: 7
    },
    date: {
        height: 15,
        width: 100,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        marginBottom: 10
    },
    fullLine: {
        height: 15,
        width: '90%',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        marginBottom: 10
    },
    haflLine: {
        height: 15,
        width: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        marginBottom: 10
    }
}

export const lightTheme = {
    palette: {
        mode: 'light',
        primary: {
            light: '#6200ea',
            main: '#673ab7',
            dark: '#311b92',
            contrastText: '#fff'
        },
        secondary: {
            light: '#304ffe',
            main: '#f05',
            dark: '#1a237e',
            contrastText: '#fff'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                a: {
                    color: '#673ab7',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease, text-decoration-color 0.2s ease'
                },
                'a:visited': {
                    color: '#5e35b1'
                },
                'a:hover, a:focus-visible': {
                    color: '#311b92',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px'
                },
                'a:active': {
                    color: '#311b92'
                },
                '.nav-container a': {
                    color: 'inherit',
                    textDecoration: 'none'
                }
            }
        },
        MuiLink: {
            defaultProps: {
                color: 'primary',
                underline: 'hover'
            }
        }
    },
    ...sharedStyles
}

export const darkTheme = {
    palette: {
        mode: 'dark',
        primary: {
            light: '#b39ddb',
            main: '#9575cd',
            dark: '#673ab7',
            contrastText: '#fff'
        },
        secondary: {
            light: '#ff6090',
            main: '#e91e63',
            dark: '#b0003a',
            contrastText: '#fff'
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                a: {
                    color: '#d1c4e9',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease, text-decoration-color 0.2s ease'
                },
                'a:visited': {
                    color: '#b39ddb'
                },
                'a:hover, a:focus-visible': {
                    color: '#ede7f6',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px'
                },
                'a:active': {
                    color: '#9575cd'
                },
                '.nav-container a': {
                    color: 'inherit',
                    textDecoration: 'none'
                }
            }
        },
        MuiLink: {
            defaultProps: {
                color: 'primary',
                underline: 'hover'
            }
        }
    },
    ...sharedStyles
}

export default lightTheme;